/* CAFFREY Revive Premium Leather Paint — page behaviour (launch build, Claude Code, 2026-10-07).
   <cf-rp-page>   numbered shade tiles -> the main form's hidden [name=id] (+ bubbling change event for the kit sticky bar
                  and Shopify's Shop Pay button), legend, hero picture (cross-fade, preloaded on pointerdown), ?variant= URL,
                  "choose your colour first" for Add to cart, Shop Pay and the sticky bar (nothing is preselected: an opened
                  bottle in the wrong colour can't go back): the message shows under the legend and the legend, message and
                  tiles scroll into view together (fix, 2026-10-07), gallery dots/thumbnails.
   <cf-rp-strip>  the carton strip: a tap chooses that shade and returns to the picture; progress line; desktop arrows.
   Respects prefers-reduced-motion. No dependencies. Dawn's <product-form> does the AJAX add and the cart notification. */
(function () {
  'use strict';
  var reduced = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  var behaviour = function () { return reduced ? 'auto' : 'smooth'; };
  var arr = function (list) { return Array.prototype.slice.call(list || []); };

  if (!customElements.get('cf-rp-page')) {
    class CfRpPage extends HTMLElement {
      connectedCallback() {
        if (this._ready) return;
        this._ready = true;
        var self = this;
        this.form = document.getElementById(this.dataset.form);
        this.idInput = this.form ? this.form.querySelector('[data-cf-rp-id]') : null;
        this.add = this.form ? this.form.querySelector('[data-cf-atc]') : null;
        this.addLabel = this.add ? this.add.querySelector('span') : null;
        this.radios = arr(this.querySelectorAll('[data-cf-rp-shade]'));
        this.tiles = this.querySelector('[data-cf-rp-tiles]');
        this.error = this.querySelector('[data-cf-rp-error]');
        this.legend = this.querySelector('[data-cf-rp-legend]');
        this.selectedEl = this.querySelector('[data-cf-rp-selected]');
        this.priceEl = this.querySelector('[data-cf-rp-price]');
        this.hero = this.querySelector('[data-cf-rp-hero]');
        this.packCaption = this.querySelector('[data-cf-rp-pack-caption]');
        this.thumb = this.querySelector('[data-cf-rp-thumb]');
        this.track = this.querySelector('[data-cf-rp-track]');
        this.gos = arr(this.querySelectorAll('[data-go]'));
        this.gallery();
        if (!this.form || !this.idInput || !this.add || !this.tiles) return;
        this.idInput.disabled = false;
        this.tiles.addEventListener('change', function (e) {
          if (e.target.matches('[data-cf-rp-shade]')) self.choose(e.target, true);
        });
        this.tiles.addEventListener('pointerdown', function (e) {
          var label = e.target.closest('label');
          var input = label ? document.getElementById(label.htmlFor) : null;
          if (!input && e.target.matches('[data-cf-rp-shade]')) input = e.target;
          if (input && !input.disabled) self.preload(input);
        }, { passive: true });
        // Capture at the document so this runs before Dawn's <product-form> submit handler on the form itself.
        document.addEventListener('submit', function (e) { if (e.target === self.form) self.validate(e); }, true);
        var pay = this.querySelector('[data-cf-rp-pay]');
        if (pay) {
          pay.addEventListener('click', function (e) {
            if (self.selected()) return;
            e.preventDefault();
            e.stopPropagation();
            self.showError();
          }, true);
        }
        window.addEventListener('pageshow', function () { self.sync(); });
        this.sync();
        this.watchSticky();
        this.dataset.ready = 'true';
      }

      selected() {
        for (var i = 0; i < this.radios.length; i++) if (this.radios[i].checked && !this.radios[i].disabled) return this.radios[i];
        return null;
      }

      anyAvailable() {
        return this.radios.some(function (r) { return !r.disabled; });
      }

      firstEnabled() {
        for (var i = 0; i < this.radios.length; i++) if (!this.radios[i].disabled) return this.radios[i];
        return null;
      }

      sync() { this.choose(this.selected(), false); }

      /* Called by the carton strip: choose a shade by variant id and bring the picture back into view. */
      pick(id, scroll) {
        var radio = this.radios.find(function (r) { return r.value === String(id); });
        if (!radio || radio.disabled) return false;
        radio.checked = true;
        this.choose(radio, true);
        if (scroll) {
          var top = this.querySelector('.cf-rp-hero') || this;
          top.scrollIntoView({ behavior: behaviour(), block: 'start' });
          try { radio.focus({ preventScroll: true }); } catch (err) { /* ignore */ }
        }
        return true;
      }

      choose(radio, user) {
        if (this.packCaption) this.packCaption.hidden = !!radio;
        var id = radio ? radio.value : '';
        if (this.idInput.value !== id) {
          this.idInput.value = id;
          this.idInput.dispatchEvent(new Event('change', { bubbles: true }));
        }
        if (this.legend) this.legend.textContent = radio ? this.dataset.colour : this.dataset.choose;
        if (this.selectedEl) this.selectedEl.textContent = radio ? radio.getAttribute('data-label') : '';
        if (radio && this.priceEl && radio.getAttribute('data-price')) this.priceEl.textContent = radio.getAttribute('data-price');
        var ok = radio ? radio.getAttribute('data-available') === 'true' : this.anyAvailable();
        this.add.disabled = !ok;
        if (this.addLabel) this.addLabel.textContent = ok ? this.dataset.add : this.dataset.soldOut;
        if (radio) {
          this.clearError();
          this.showPack(radio, user);
        }
        if (user && radio && window.history && history.replaceState) {
          try {
            var u = new URL(window.location.href);
            u.searchParams.set('variant', radio.value);
            history.replaceState(history.state, '', u.toString());
          } catch (err) { /* ignore */ }
        }
        this.patchSticky();
        document.dispatchEvent(new CustomEvent('cf-rp:shade', { detail: { id: id } }));
      }

      preload(radio) {
        if (!radio.dataset.src || radio._pre) return;
        var im = new Image();
        im.sizes = this.hero ? this.hero.sizes : '100vw';
        im.srcset = radio.dataset.srcset || '';
        im.src = radio.dataset.src;
        radio._pre = im;
      }

      showPack(radio, user) {
        var img = this.hero;
        if (!img || !radio.dataset.src) return;
        if (img.getAttribute('data-shade') === radio.value) return;
        img.setAttribute('data-shade', radio.value);
        if (this.thumb && radio.dataset.thumb) { this.thumb.src = radio.dataset.thumb; this.thumb.setAttribute('height', '384'); }
        if (user) this.goTo(0);
        var apply = function () {
          if (img.getAttribute('data-shade') !== radio.value) return;
          img.srcset = radio.dataset.srcset || '';
          img.src = radio.dataset.src;
          img.alt = radio.dataset.alt || radio.dataset.label;
          img.setAttribute('width', '900');
          img.classList.remove('is-swapping');
        };
        if (reduced || !user) { apply(); return; }
        this.preload(radio);
        img.classList.add('is-swapping');
        var done = false;
        var finish = function () { if (done) return; done = true; apply(); };
        var pre = radio._pre;
        if (pre && pre.decode) pre.decode().then(finish, finish); else finish();
        setTimeout(finish, 900);
      }

      validate(e) {
        if (this.selected()) { this.clearError(); return; }
        e.preventDefault();
        e.stopImmediatePropagation();
        this.showError();
        var sticky = document.querySelector('cf-kit-sticky');
        if (sticky && typeof sticky.done === 'function') sticky.done();
      }

      /* "Choose your colour first." sits between the legend and the tiles (fix 2026-10-07). A repeated tap re-announces it
         (role=alert) and replays a short fade so the shopper sees the page answered. */
      showError() {
        var msg = this.dataset.chooseFirst;
        var el = this.error;
        if (el) {
          var again = !el.hidden && el.textContent === msg;
          el.hidden = false;
          el.classList.remove('is-on');
          void el.offsetWidth;
          el.classList.add('is-on');
          if (again) {
            el.textContent = '\u00a0';
            setTimeout(function () { el.textContent = msg; }, 80);
          } else {
            el.textContent = msg;
          }
        }
        this.tiles.setAttribute('aria-invalid', 'true');
        this.reveal();
        var first = this.firstEnabled();
        if (first) { try { first.focus({ preventScroll: true }); } catch (err) { first.focus(); } }
      }

      /* Bring the legend, the message and every tile into view together. Both taps that lead here (Add to cart under the
         tiles, the sticky bar far below) scroll UP, and this store's header is sticky on scroll-up, so its height is kept
         clear at the top; a short bottom overlay (Klaviyo teaser, --cf-bottom-overlay from the kit) is kept clear at the
         bottom. The sticky bar hides by itself once Add to cart is back in view under the tiles. */
      reveal() {
        var box = this.tiles.closest('fieldset') || this.tiles;
        var r = box.getBoundingClientRect();
        var vh = window.innerHeight || document.documentElement.clientHeight;
        var hdr = document.querySelector('sticky-header');
        var head = hdr ? Math.min(Math.round(hdr.getBoundingClientRect().height), 160) : 0;
        var over = parseFloat(getComputedStyle(document.documentElement).getPropertyValue('--cf-bottom-overlay')) || 0;
        var top = head + 12;
        var bottom = Math.min(over, 160) + 12;
        if (r.top >= top && r.bottom <= vh - bottom) return;
        window.scrollTo({ top: Math.max(0, Math.round(window.pageYOffset + r.top - top)), behavior: behaviour() });
      }

      clearError() {
        if (this.error) { this.error.textContent = ''; this.error.hidden = true; this.error.classList.remove('is-on'); }
        if (this.tiles) this.tiles.removeAttribute('aria-invalid');
      }

      /* Gallery: native scroll-snap; dots (phone) and thumbnails (desktop) follow the visible slide. */
      gallery() {
        var self = this;
        var track = this.track;
        if (!track) return;
        this.gos.forEach(function (b) {
          b.addEventListener('click', function () { self.goTo(Number(b.getAttribute('data-go'))); });
        });
        var raf = null;
        track.addEventListener('scroll', function () {
          if (raf) return;
          raf = requestAnimationFrame(function () {
            raf = null;
            self.mark(Math.round(track.scrollLeft / Math.max(1, track.clientWidth)));
          });
        }, { passive: true });
      }

      goTo(i) {
        var t = this.track;
        if (!t) return;
        t.scrollTo({ left: i * t.clientWidth, behavior: behaviour() });
        this.mark(i);
      }

      mark(i) {
        this.gos.forEach(function (b) { b.setAttribute('aria-current', String(Number(b.getAttribute('data-go')) === i)); });
      }

      /* The kit sticky bar treats "no variant" as unavailable. With nothing preselected it shows "Choose your colour" and
         keeps an active "Add to cart" that clicks the main button, whose check leads the shopper to the tiles. Once a
         shade is chosen it shows the printed code and name ("80 Classic Blue") instead of the bare variant title. */
      watchSticky() {
        var self = this;
        var tries = 0;
        var attach = function () {
          var st = document.querySelector('cf-kit-sticky');
          if (!st) { if (++tries < 20) setTimeout(attach, 250); return; }
          if (self._stickyObs) return;
          self._sticky = st;
          self._stickyObs = new MutationObserver(function () { self.patchSticky(); });
          self._stickyObs.observe(st, { subtree: true, childList: true, characterData: true, attributes: true, attributeFilter: ['disabled'] });
          self.patchSticky();
        };
        attach();
      }

      patchSticky() {
        var st = this._sticky;
        if (!st) return;
        var btn = st.querySelector('[data-cf-sticky-atc]');
        var label = btn ? btn.querySelector('span') : null;
        var v = st.querySelector('[data-cf-sticky-variant]');
        var sel = this.selected();
        if (!sel) {
          if (!this.anyAvailable()) return;
          if (btn && btn.disabled) btn.disabled = false;
          if (label && label.textContent !== this.dataset.add) label.textContent = this.dataset.add;
          if (v && v.textContent !== this.dataset.choose) v.textContent = this.dataset.choose;
        } else if (v && v.textContent !== sel.getAttribute('data-label')) {
          v.textContent = sel.getAttribute('data-label');
        }
      }
    }
    customElements.define('cf-rp-page', CfRpPage);
  }

  if (!customElements.get('cf-rp-strip')) {
    class CfRpStrip extends HTMLElement {
      connectedCallback() {
        if (this._ready) return;
        this._ready = true;
        var self = this;
        this.track = this.querySelector('[data-cf-rp-strip-track]');
        this.bar = this.querySelector('[data-cf-rp-strip-bar] span');
        this.prev = this.querySelector('[data-cf-rp-strip-prev]');
        this.next = this.querySelector('[data-cf-rp-strip-next]');
        if (!this.track) return;
        this.addEventListener('click', function (e) {
          var a = e.target.closest('a[data-variant]');
          if (!a) return;
          var page = document.querySelector('cf-rp-page');
          if (!page || typeof page.pick !== 'function') return;
          if (page.pick(a.getAttribute('data-variant'), true)) e.preventDefault();
        });
        var raf = null;
        var update = function () {
          if (raf) return;
          raf = requestAnimationFrame(function () { raf = null; self.update(); });
        };
        this.track.addEventListener('scroll', update, { passive: true });
        window.addEventListener('resize', update, { passive: true });
        if (this.prev) this.prev.addEventListener('click', function () { self.page(-1); });
        if (this.next) this.next.addEventListener('click', function () { self.page(1); });
        document.addEventListener('cf-rp:shade', function (e) { self.markCurrent(e.detail && e.detail.id); });
        var page = document.querySelector('cf-rp-page');
        var cur = page && typeof page.selected === 'function' ? page.selected() : null;
        if (cur) this.markCurrent(cur.value);
        this.update();
      }

      page(dir) {
        var t = this.track;
        t.scrollBy({ left: dir * Math.max(120, t.clientWidth * 0.85), behavior: behaviour() });
      }

      update() {
        var t = this.track;
        var max = t.scrollWidth - t.clientWidth;
        if (this.bar) {
          var vis = t.scrollWidth > 0 ? Math.min(1, t.clientWidth / t.scrollWidth) : 1;
          var pos = max > 0 ? t.scrollLeft / max : 0;
          this.bar.style.width = (vis * 100).toFixed(2) + '%';
          this.bar.style.transform = 'translateX(' + (pos * (1 / vis - 1) * 100).toFixed(2) + '%)';
          this.bar.parentElement.hidden = max <= 1;
        }
        if (this.prev) this.prev.disabled = t.scrollLeft <= 1;
        if (this.next) this.next.disabled = t.scrollLeft >= max - 1;
      }

      markCurrent(id) {
        arr(this.querySelectorAll('a[data-variant]')).forEach(function (a) {
          if (id && a.getAttribute('data-variant') === String(id)) a.setAttribute('aria-current', 'true');
          else a.removeAttribute('aria-current');
        });
      }
    }
    customElements.define('cf-rp-strip', CfRpStrip);
  }
})();
